// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ndmC","comment":"styles_comment__3_4EY"};